import React  from "react";
import "./page-wrapper.css";
import ImageLogo from "../../../images/bharat.png";

function PageWrapper({ title, children }) {
  function handleOutsideClick() {
    document.body.classList.remove("effect");
  }
  return (
    <div className="main-wrapper" onClick={handleOutsideClick}>
      <div className="page-header">
        <div className="container">
          <h1 className="text-white">{title}</h1>
        </div>
      </div>

      <div className="container">
        <div className="card overlap_30">
          <img src={ImageLogo} alt="logo" className="biller_img_cat" width={110}></img>
          <div className="card-body trans_bg py-4">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default PageWrapper;
